const state = {
  data_dropdown: null,
};

const getters = {
  data_dropdown(state) {
    return state.data_dropdown;
  },
};

const mutations = {
  setDataDropdown(state, payload) {
    state.data_dropdown = payload;
  },
};

const actions = {
  setDataDropdown(context, payload) {
    context.commit('setDataDropdown', payload);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
